import { faLightbulb } from '@fortawesome/pro-solid-svg-icons';

import { Body, Icon, Tag, cn } from '@growtherapy/sprout-ui';

import { ModifiedToastAria, Toast } from '../../toasts';
import { ToastButton } from '../../toasts/ToastButton';

export function PromptFollowUpToast({
  title,
  subtitle,
  callToAction,
  onCallToAction,
  contentProps,
  titleProps,
  descriptionProps,
  ...toastAriaProps
}: {
  title: string;
  subtitle: React.ReactNode;
  callToAction?: string;
  onCallToAction?: () => void;
} & ModifiedToastAria) {
  if (callToAction && onCallToAction) {
    return (
      <Toast {...toastAriaProps} alignment='center' className='max-w-[40rem] w-full sm:w-full' closeButtonSize='sm'>
        <div className='flex flex-1 flex-col md:flex-row md:justify-between gap-3 min-w-0 w-full md:items-center'>
          <div {...contentProps} className={cn('flex min-w-0 w-full flex-col gap-1 md:w-max', contentProps?.className)}>
            <Body.Default as='h3' {...titleProps} className={cn('!font-semibold', titleProps?.className)}>
              {title}
            </Body.Default>
            <Body.Small as='span' {...descriptionProps} className={descriptionProps?.className}>
              {subtitle}
            </Body.Small>
          </div>
          <ToastButton
            className='self-end md:self-auto rebrand:max-h-none rebrand:shrink-0'
            use='secondary'
            onClick={onCallToAction}
          >
            {callToAction}
          </ToastButton>
        </div>
      </Toast>
    );
  }

  return (
    <Toast {...toastAriaProps} alignment='top' className='sm:max-w-sm'>
      <div className='flex gap-4 align-start flex-col' {...contentProps}>
        <div className='flex justify-between'>
          <Tag use='lilac' className='flex flex-row justify-start items-center gap-2 px-2 py-1'>
            <Icon aria-hidden icon={faLightbulb} />
            <Body.Xsmall {...titleProps}>{title}</Body.Xsmall>
          </Tag>
        </div>
        <Body.Small {...descriptionProps}>{subtitle}</Body.Small>
      </div>
    </Toast>
  );
}
